import React, { useEffect } from 'react';
import { Request } from '../../components/request';
import { ContentSection, Heading } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';

export const RequestPage: React.FC = () => {
    const { t } = useTranslation('request');
    const title = t('headline');

    useEffect(() => {
        document.title = 'Soumettre une demande';
    }, []);

    return (
        <ContentSection pageWrapSize="medium">
            <Heading level={1}>{title}</Heading>
            <Request />
        </ContentSection>
    );
};
